import { PayloadAction } from '@reduxjs/toolkit';

import initialState from './state';

const setIsFetchingData = (state, action: PayloadAction<boolean>) => {
  state.isFetchingData = action.payload;
  state.total = 31;
  state.completed = [];
  state.hasData = false;
};

const resetAllLoaders = (state, action: PayloadAction<undefined>) => {
  state = initialState;
  return state;
};

export { setIsFetchingData, resetAllLoaders };
